const youtubeChannelUrl = (channelId, usesSlug = false) => {
  if (usesSlug) {
    return `https://www.youtube.com/c/${channelId}`
  } else {
    return `https://www.youtube.com/channel/${channelId}`    
  }
}

const instagramProfileUrl = (profileId) => `https://www.instagram.com/${profileId}/`

const tiktokProfileUrl = (profileId) => `https://www.tiktok.com/@${profileId}?lang=en`

export {
  youtubeChannelUrl,
  instagramProfileUrl,
  tiktokProfileUrl
}
